import axios from 'axios';
import Swal from 'sweetalert2';
import { api } from '../../domainConfig';


/* eslint no-shadow: ["error", { "allow": ["state"] }] */

const domain = api.userManagementDomain;
const domain2 = api.stockManagementDomain;
const domain3 = api.clientMasterDataDomain;

const state = {
  status: false,
  teams: [],
  filteredTeams: [],
  teamsOrders: [],
  articles: [],
  articlesMaterials: [],
  teamOverview: {},
  freeSewers: [],
  freePatronists: [],
  freeHandSewers: [],
  freeTeamLeaders: [],
  dropdownTeamName: [],
  freeUsers: [],
  allFreeUsers: [],
  userByRole: [],
  teamVacationOverview: [],
  employeeVacation: [],
  currentPage: 1,
  totalItems: 0,
  teamsNames: [],
  campaigns: [],
  campaignOccasions: [],
  campaignLeads: [],
  totalCampaigns: 0,
  campaignCurrentPage: 1,
  campaigns: [],
};

const getters = {
  getTeams: (state) => {
    return state.teams;
  },
  getEmployeeVacation: (state) => {
    return state.employeeVacation
  },
  getTeamVacationOverview: (state) => {
    return state.teamVacationOverview
  },
  getTeamsForPassiveStuck: (state) => {
    // state.teams.unshift('ALL');
    return state.teams;
  },
  getTeamsNames: (state) => {
    return state.teamsNames
  },
  getFilteredTeams: (state) => {
    return state.filteredTeams;
  },
  getTeamOverview: (state) => {
    return state.teamOverview;
  },

  getTeamOrders: (state) => {
    return state.teamsOrders;
  },

  getArticles: (state) => {
    return state.articles;
  },
  getArticlesMaterials: (state) => {
    return state.articlesMaterials;
  },
  getFreeTeamLeaders: (state) => {
    return state.freeTeamLeaders;
  },
  getFreeUsers: (state) => {
    return state.freeUsers;
  },
  getAllFreeUsers: (state) => {
    return state.allFreeUsers;
  },
  getUsersByRole: (state) => {
    return state.userByRole
  },
  getCurrentPageForTeams: (state) => {
    return state.currentPage;
  },

  //   getFilteredUsers: (state) => {
  //     return state.fileteredUsers;
  //   },

  getTotalItemsForTeams: (state) => {
    return state.totalItems;
  },
  getDropdownTeamName: (state) => {
    return state.dropdownTeamName
  },
  getCampaigns: (state) => {
    return state.campaigns;
  },
  getCampaignCurrentPage: (state) => state.campaignCurrentPage,
  getCampaigns: (state) => {
    return state.campaigns;
  },
  getCampaignOccasions: (state) => {
    return state.campaignOccasions;
  },
  getCampaignLeads: (state) => {
    return state.campaignLeads;
  },
  getTotalCampaigns: (state) => {
    return state.totalCampaigns;
  },

};

const mutations = {
  SET_STATUS(state, payload) {
    state.status = payload;
  },
  SET_CURRENTPAGE(state, payload) {
    state.currentPage = payload;
  },
  SET_EMPLOYEE_VACATION(state, payload) {
    state.employeeVacation = payload;
  },
  SET_TEAM_VACATION_OVERVIEW(state, payload) {
    state.teamVacationOverview = payload;
  },
  SET_TEAMS(state, latest) {
    state.teams = latest;
  },
  SET_USERS_BY_ROLE(state, latest) {
    state.userByRole = latest
  },
  SET_FILTERED_TEAMS(state, latest) {
    state.filteredTeams = latest;
  },
  SET_ARTICLES(state, latest) {
    state.articles = latest;
  },
  SET_ARTICLES_MATERIALS(state, latest) {
    state.articlesMaterials = latest;
  },
  SET_TEAM_ORDERS(state, latest) {
    state.teamsOrders = latest;
  },
  SET_TEAM_OVERVIEW(state, latest) {
    state.teamOverview = latest;
  },
  SET_FREE_USERS_BY_ROLE(state, latest) {
    state.freeUsers = latest;
  },
  SET_ALL_FREE_USERS_BY_ROLE(state, latest) {
    state.allFreeUsers = latest;
  },
  SET_FREE_TEAM_LEADERS(state, latest) {
    state.freeTeamLeaders = latest;
  },
  //   SET_FILTERED_USERS(state, latest) {
  //     state.fileteredUsers = latest;
  //   },
  SET_TOTALITEMS_TEAMS(state, latest) {
    state.totalItems = latest;
  },
  SET_DROPDOWN_TEAMNAME(state, latest) {
    state.dropdownTeamName = latest
  },
  SET_TEAMS_NAMES(state, latest) {
    state.teamsNames = latest
  },
  SET_CAMPAIGNS(state, latest) {
    state.campaigns = latest;
  },
  SET_CAMPAIGN_CURRENT_PAGE(state, latest) {
    state.campaignCurrentPage = latest;
  },
  SET_CAMPAIGNS(state, latest) {
    state.campaigns = latest;
  },
  SET_CAMPAIGN_OCCASIONS(state, latest) {
    state.campaignOccasions = latest;
  },
  SET_CAMPAIGN_LEADS(state, latest) {
    state.campaignLeads = latest;
  },
  SET_TOTAL_CAMPAIGNS(state, latest) {
    state.totalCampaigns = latest;
  },
};
const actions = {
  async fetchCampaignOccasions({ commit }) {
    commit('SET_IS_LOADING', false);
    try {
      const response = await axios.get(`${domain2}/campaigns/lov-occasions`);
      commit('SET_CAMPAIGN_OCCASIONS', response.data);
      return response.data;
    } catch (error) {
      commit('SET_IS_LOADING', true);
      console.error('Error fetching campaign occasions', error);
      throw error;
    } finally {
      commit('SET_IS_LOADING', true);
    }
  },
  async campaignPagination({ commit }, { pageNumber = 1, pageSize = 15 } = {}) {
    commit('SET_IS_LOADING', false);
    try {
      const response = await axios.get(`${domain2}/campaigns`, {
        params: { pageNumber, pageSize },
      });
      commit('SET_CAMPAIGNS', response.data.items || response.data);
      commit('SET_CAMPAIGN_CURRENT_PAGE', response.data.currentPage || 1);
      commit('SET_TOTAL_CAMPAIGNS', response.data.totalItems || (response.data.items ? response.data.items.length : 0));
      return response.data;
    } catch (error) {
      commit('SET_IS_LOADING', true);
      console.error('Error fetching campaigns', error);
      throw error;
    } finally {
      commit('SET_IS_LOADING', true);
    }
  },
  async addCampaign({ commit }, { object, successCallback }) {
    commit('SET_IS_LOADING', false);
    try {
      await axios.post(`${domain2}/campaigns/add`, object, { headers: { 'Content-Type': 'application/json' } });
      commit('SET_STATUS', true);
      if (successCallback) successCallback();
      Swal.fire({
        icon: 'success',
        title: 'Campaign added succesfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
    } catch (error) {
      if (error.response && error.response.status === 400) {
        Swal.fire({ icon: 'error', title: 'Invalid campaign data. Please try again.', toast: true, position: 'top-end', showConfirmButton: false, timer: 2500 });
      } else if (error.response) {
        Swal.fire({ icon: 'error', title: error.response.data.Message || 'Error adding campaign', toast: true, position: 'top-end', showConfirmButton: false, timer: 2500 });
      }
      console.error('Error adding campaign', error);
      throw error;
    } finally {
      commit('SET_IS_LOADING', true);
    }
  },
  async campaignLeads({ commit }, { campaignId, pageNumber = 1, pageSize = 15 } = {}) {
    commit('SET_IS_LOADING', false);
    try {
      const response = await axios.get(`${domain2}/campaign/leads`, {
        params: { campaignId, pageNumber, pageSize },
      });
      commit('SET_CAMPAIGN_LEADS', response.data.items || response.data);
      return response.data;
    } catch (error) {
      commit('SET_IS_LOADING', true);
      console.error('Error fetching campaign leads', error);
      throw error;
    } finally {
      commit('SET_IS_LOADING', true);
    }
  },
  async addLeadClientInternal({ commit }, { object, successCallback } = {}) {
    commit('SET_IS_LOADING', false);
    try {
      const response = await axios.post(`${domain3}/add-lead-client-internal`, object, { headers: { 'Content-Type': 'application/json' } });
      commit('SET_STATUS', true);
      if (successCallback) successCallback(response.data);
      Swal.fire({ icon: 'success', title: 'Lead added succesfully', toast: true, position: 'top-end', showConfirmButton: false, timer: 2500 });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        Swal.fire({ icon: 'error', title: error.response.data.Message || 'Error adding lead', toast: true, position: 'top-end', showConfirmButton: false, timer: 2500 });
      }
      console.error('Error adding lead', error);
      throw error;
    } finally {
      commit('SET_IS_LOADING', true);
    }
  },
  async addCampaignLead({ commit }, { object, successCallback } = {}) {
    commit('SET_IS_LOADING', false);
    try {
      const response = await axios.post(`${domain2}/campaigns/add-lead`, object, { headers: { 'Content-Type': 'application/json' } });
      commit('SET_STATUS', true);
      if (successCallback) successCallback(response.data);
      Swal.fire({ icon: 'success', title: 'Lead added succesfully', toast: true, position: 'top-end', showConfirmButton: false, timer: 2500 });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        Swal.fire({ icon: 'error', title: error.response.data.Message || 'Error adding lead', toast: true, position: 'top-end', showConfirmButton: false, timer: 2500 });
      }
      console.error('Error adding lead', error);
      throw error;
    } finally {
      commit('SET_IS_LOADING', true);
    }
  },
  async getTeamsPagination({ commit }, { pageNumber, pageSize }) {
    commit('SET_IS_LOADING', false);
    try {
      const response = await axios.get(`${domain}/getTeamNamesPagination`, {
        params: {
          pageNumber,
          pageSize,
        },
      });
      commit('SET_TEAMS', response.data.items);
      commit('SET_CURRENTPAGE', response.data.currentPage);
      commit('SET_TOTALITEMS_TEAMS', response.data.totalItems);
    } catch (error) {
      commit('SET_IS_LOADING', true)
    }
    commit('SET_IS_LOADING', true);
  },
  async teamNames({ commit }, { startFilterPickUpDate, endFilterPickUpDate }) {
    commit('SET_IS_LOADING', false);
    try {
      const response = await axios.get(`${domain}/team_names_active_pickup_orders`, {
        params: {
          startFilterPickUpDate,
          endFilterPickUpDate,
        },
      });
      commit('SET_TEAMS_NAMES', response.data);
    } catch (error) {
      commit('SET_IS_LOADING', true)
    }
    commit('SET_IS_LOADING', true);
  },

  async dropdown_TeamNames({ commit }, numberOfEntries) {
    commit('SET_IS_LOADING', false);
    try {
      const response = await axios.get(`${domain}/dropdown_TeamNames?numberOfEntries=${numberOfEntries}`);
      commit('SET_DROPDOWN_TEAMNAME', response.data);
    } catch (error) {
      commit('SET_IS_LOADING', true)
    }
    commit('SET_IS_LOADING', true);
  },
  async usersByRole({ commit }, { personRole }) {
    commit('SET_IS_LOADING', false);
    try {
      const response = await axios.get(`${domain}/users_by_Role?personRole=${personRole}`);
      commit('SET_USERS_BY_ROLE', response.data);
    } catch (error) {
      commit('SET_IS_LOADING', true)
    }
    commit('SET_IS_LOADING', true);
  },
  async getOrderItemsManagementBy({ commit }, { orderNr, id }) {
    commit('SET_IS_LOADING', false);
    try {
      const response = await axios.get(`${domain2}/orderItemsManagementBy/${orderNr}/${id}`);
      commit('SET_ARTICLES', response.data);
    } catch (error) {
      commit('SET_IS_LOADING', true)
    }
    commit('SET_IS_LOADING', true);
  },
  async getOrderItemsManagementByMaterials({ commit }, { orderNr, id }) {
    commit('SET_IS_LOADING', false);
    try {
      const response = await axios.get(`${domain2}/material_orderItemsManagementBy/${orderNr}/${id}`);
      commit('SET_ARTICLES_MATERIALS', response.data);
    } catch (error) {
      commit('SET_IS_LOADING', true)
    }
    commit('SET_IS_LOADING', true);
  },
  async resetGetOrderItemsManagementBy({ commit }) {
    commit('SET_ARTICLES', []);
  },
  async resetGetOrderItemsManagementByMaterials({ commit }) {
    commit('SET_ARTICLES_MATERIALS', []);
  },
  async getOrderById({ commit }, {
    id, salesType, startFilterPickUpDate, endFilterPickUpDate,
  }) {
    commit('SET_IS_LOADING', false);
    try {
      const response = await axios.get(`${domain2}/ordersBy/${id}?salesType=${salesType}`, {
        params: {
          startFilterPickUpDate,
          endFilterPickUpDate,
        },
      });
      commit('SET_TEAM_ORDERS', response.data)
    } catch (error) {
      commit('SET_IS_LOADING', true)
    }
    commit('SET_IS_LOADING', true);
  },
  resergetOrderById({ commit }) {
    commit('SET_TEAM_ORDERS', [])
  },
  async employeeVacation({ commit }, {
    exactDate, startDate, endDate, year,
  }) {
    commit('SET_IS_LOADING', false);
    try {
      const response = await axios.get(`${domain}/employeeVacations`, {
        params: {
          exactDate,
          startDate,
          endDate,
          year,
        },
      });

      commit('SET_EMPLOYEE_VACATION', response.data);
    } catch (error) {
      commit('SET_IS_LOADING', true)
    }
    commit('SET_IS_LOADING', true);
  },
  async teamVacationOverview({ commit }, {
    teamNameId, year,
  }) {
    commit('SET_IS_LOADING', false);
    try {
      const response = await axios.get(`${domain}/team_vacations_Overview`, {
        params: {
          teamNameId,
          year,
        },
      });

      commit('SET_TEAM_VACATION_OVERVIEW', response.data);
    } catch (error) {
      commit('SET_IS_LOADING', true)
    }
    commit('SET_IS_LOADING', true);
  },
  async teamByTeamNameId({ commit }, teamNameId) {
    commit('SET_IS_LOADING', false);
    try {
      const response = await axios.get(`${domain}/teamOverviewByTeamNameId?teamNameId=${teamNameId}`);
      commit('SET_TEAM_OVERVIEW', response.data);
    } catch (error) {
      commit('SET_IS_LOADING', true)
    }
    commit('SET_IS_LOADING', true);
  },

  async addTeam({ commit }, { object, successCallback }) {
    // const objToJson = JSON.stringify(object)
    commit('SET_IS_LOADING', false);
    try {
      await axios.post(`${domain}/addTeam`, object, {
        headers: { 'Content-Type': 'application/json' },
      });
      commit('SET_STATUS', true)
      successCallback()
      Swal.fire({
        icon: 'success',
        title: 'Team added succesfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
    } catch (error) {
    // Handle error response
    // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid team data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_IS_LOADING', true);
      }
    }
    commit('SET_IS_LOADING', true);
  },
  async loadFreeTeamLeadersPagination({ commit }, { pageNumber, pageSize } = {}) {
    commit('SET_IS_LOADING', false);
    try {
      const response = await axios.get(`${domain}/getFreeTeamLeadersPagination`, {
        params: {
          pageNumber,
          pageSize,
        },
      })
      commit('SET_FREE_TEAM_LEADERS', response.data.items)
    } catch (error) {
      commit('SET_IS_LOADING', true)
    }
    commit('SET_IS_LOADING', true);
  },
  async loadFreeUsersByRolePagination({ commit }, { personRole, pageNumber, pageSize } = {}) {
    commit('SET_IS_LOADING', false);
    try {
      const response = await axios.get(`${domain}/getFreeUsersByRolePagination`, {
        params: {
          personRole,
          pageNumber,
          pageSize,
        },
      })
      commit('SET_FREE_USERS_BY_ROLE', response.data.items)
    } catch (error) {
      commit('SET_IS_LOADING', true)
    }
    commit('SET_IS_LOADING', true);
  },
  async loadAllFreeUsersByRolePagination({ commit }, { personRole }) {
    commit('SET_IS_LOADING', false);
    try {
      const response = await axios.get(`${domain}/all_free_users_by_role`, {
        params: {
          personRole,
        },
      })
      commit('SET_ALL_FREE_USERS_BY_ROLE', response.data)
    } catch (error) {
      commit('SET_IS_LOADING', true)
    }
    commit('SET_IS_LOADING', true);
  },
  async editTeam({ commit }, { teamNameId, object, successCallback }) {
    commit('SET_IS_LOADING', false);
    try {
      await axios.put(`${domain}/editTeamByTeamNameId?teamNameId=${teamNameId}`, object);
      commit('SET_STATUS', true);
      successCallback()
      Swal.fire({
        icon: 'success',
        title: 'Team edited succesfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
    } catch (error) {
    // Handle error response
    // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid team data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_IS_LOADING', true);
      }
    }
    commit('SET_IS_LOADING', true);
  },
  async getTeamNameByNameLike({ commit }, teamName) {
    if (teamName == '') {
      commit('SET_FILTERED_TEAMS', []);
      return;
    }
    commit('SET_IS_LOADING', false);
    try {
      const response = await axios.get(`${domain}/getTeamNamesByNameLike?teamName=${teamName}`);
      commit('SET_FILTERED_TEAMS', response.data);
    } catch (error) {
      commit('SET_IS_LOADING', true)
    }
    commit('SET_IS_LOADING', true);
  },
  async assignOrderItemToTeamLeader({ commit }, { object, successCallback }) {
    commit('SET_IS_LOADING', false);
    try {
      const response = await axios.put(`${domain2}/assignOrderItemToTeam`, object);
      commit('SET_STATUS', true);
      const newState = response.data.newState;
      successCallback();
      if (newState === 'Assigned') {
        Swal.fire({
          icon: 'success',
          title: `Order item changed to state: ${newState}`,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: `Order item changed to state: ${newState}`,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } catch (error) {
      // Handle error response
      if (error.response) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_IS_LOADING', true);
      }
    }
    commit('SET_IS_LOADING', true);
  },
    async getCampaigns({ commit }) {
      commit('SET_IS_LOADING', false);
      try {
        const response = await axios.get(`${domain2}/campaigns`);
        commit('SET_CAMPAIGNS', response.data.items || response.data);
        commit('SET_TOTAL_CAMPAIGNS', response.data.totalItems || (response.data.items ? response.data.items.length : 0));
      } catch (error) {
        console.error('Error fetching campaigns', error);
      } finally {
        commit('SET_IS_LOADING', true);
      }
    },
  async addCampaignLovOccasion({ commit }, { name, successCallback }) {
  commit('SET_IS_LOADING', false)
  try {
    await axios.post(
      `${domain2}/campaigns/add-lov-occasion`,
      {}, // empty body (important)
      {
        params: { name },
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    Swal.fire({
      icon: 'success',
      title: 'Campaign occasion added successfully',
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 2500,
    })

    if (successCallback) successCallback()
  } catch (error) {
    Swal.fire({
      icon: 'error',
      title: error.response?.data?.Message || 'Error adding campaign occasion',
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 2500,
    })
    throw error
  } finally {
    commit('SET_IS_LOADING', true)
  }
},
};

export default {
  state,
  getters,
  mutations,
  actions,
};
